










import {Component, Vue} from 'vue-property-decorator';
import Snackbar from './modules/snackbar/_components/Snackbar.vue';
import LoaderFullscreen from './modules/loader/_components/LoaderFullscreen.vue';

@Component({
  components: {
    Snackbar,
    LoaderFullscreen,
  },
})
export default class App extends Vue {
}
